import { render, staticRenderFns } from "./AppointmentUserAnalytic.vue?vue&type=template&id=594138da"
import script from "./AppointmentUserAnalytic.vue?vue&type=script&lang=js"
export * from "./AppointmentUserAnalytic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports